import script from "./allocation.vue?vue&type=script&lang=ts&setup=true"
export * from "./allocation.vue?vue&type=script&lang=ts&setup=true"

import "./allocation.vue?vue&type=style&index=0&id=19864347&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19864347"]])

export default __exports__